export namespace InvestigativeSite {
  export enum DraftEntityTypes {
    SchulmanIrb = 1,
  }

  export enum DraftStatus {
    Pending = 1,
    Resolved = 2,
    Deleted = 3,
  }

  export enum Status {
    Pending = 1,
    Active = 2,
    Enrolling = 3,
    NonParticipating = 4,
    Rejected = 5,
    Maintenance = 6,
    Closed = 7,
    Selected = 8,
    Terminated = 9,
    Approved = 10,
    Deselected = 11,
    CloseOut = 12,
    OnHold = 13,
    Postponed = 14,
    SDDS = 15,
    Assessment = 16,
    Potential = 17,
    Closeout = 18,
    Planned = 19,
    New = 20,
    APPROVEDActivated = 21,
    NotInterested = 22,
    Canceled = 23,
  }

  export enum ContactStatus {
    Active = 1,
    Inactive = 2,
  }

  export const ContactStatusStrings = {
    [ContactStatus.Active]: 'Active',
    [ContactStatus.Inactive]: 'Inactive',
  };

  export const ContactStatusDropdown = [
    { text: ContactStatusStrings[ContactStatus.Active], value: ContactStatus.Active },
    { text: ContactStatusStrings[ContactStatus.Inactive], value: ContactStatus.Inactive },
  ];

  export enum PreferredCommunicationMode {
    Email = 1,
    Fax = 2,
    Phone = 3,
  }

  export enum EFeasibilityStatus {
    Sent = 1,
    Received = 2,
    Approved = 3,
  }

  export enum FilterMode {
    NoFilterStart = 0,
    Sponsor = 1,
    Country = 2,
    ByInvestigativeSiteId = 3,
    Expiring = 4,
    SAS = 5,
    Status = 6,
    Irb = 7,
    RecentSites = 8,
    ByEmailDomainAddress = 9,
    ForEvents = 10,
    ByAnyContact = 11,
    NoFilterEnd = 12,
  }

  export enum InvestigativeSiteSecurityType {
    Reader = 1,
    Editor = 2,
    ProtectedDocuments = 3,
    SiteOthers = 4,
    SiteCra = 5,
  }

  export enum AssignOption {
    Replace = 1,
    Append = 2,
  }
}
